var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5001_17527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6055 7.13245H13.6055V9.13245H11.6055V7.13245ZM11.6055 11.1324H13.6055V17.1324H11.6055V11.1324ZM12.6055 2.13245C7.08547 2.13245 2.60547 6.61245 2.60547 12.1324C2.60547 17.6524 7.08547 22.1324 12.6055 22.1324C18.1255 22.1324 22.6055 17.6524 22.6055 12.1324C22.6055 6.61245 18.1255 2.13245 12.6055 2.13245ZM12.6055 20.1324C8.19547 20.1324 4.60547 16.5424 4.60547 12.1324C4.60547 7.72245 8.19547 4.13245 12.6055 4.13245C17.0155 4.13245 20.6055 7.72245 20.6055 12.1324C20.6055 16.5424 17.0155 20.1324 12.6055 20.1324Z",
    fill: "#086CE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5001_17527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.605469 0.132446)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.185aca28c7176cd8e9a77feeb226e381.svg";
export { ForwardRef as ReactComponent };